import React, { useEffect } from 'react'
import { DI, DIProps } from '../../../Core';
import { StepType, useTour } from '../../Other/tour';
import { BlockStack, Box, Button, InlineStack, Text } from '@shopify/polaris';
import { appBridgeRouting } from '../Panel/index';
import { useTranslation } from 'react-i18next';

const ConfigTour = (props: DIProps & { handleTabChange: (seletedIndex: number) => void; templateSettingsIndex: number; currentSelectedIndex: number }) => {
    const { t } = useTranslation();
    const { setIsOpen, setCurrentStep, setSteps } = useTour();

    const endTour = () => {
        props.di.POST('connector/config/saveConfig', {
            data: [
                {
                    data: JSON.parse(
                        JSON.stringify(
                            {
                                bulk_upload_tour: {
                                    parts_visited: 5,
                                },
                            }
                        )
                    ),
                    group_code: 'tour',
                },
            ],
        }).then((response: any) => {
            setIsOpen(false);
            props.di.globalState.removeLocalStorage('start_tour');
            if (response.success)
                return;
            props.error(
                'Failed to end tour'
            );
        });
    }

    const getTourData = () => {
        props.di.POST("connector/config/getConfig", {
            group_code: ["tour"],
        }).then((response: any) => {
            if (response.success) {
                let value = response.data.find((a: any) => a.group_code === 'tour')?.value
                if (value?.bulk_upload_tour) {
                    const parts_visited = value?.bulk_upload_tour?.parts_visited ?? 0
                    if (parts_visited === 1) {
                        setIsOpen(true);
                        setCurrentStep(0);
                        setSteps?.(steps)
                    }
                    else if (parts_visited === 3) {
                        setIsOpen(true);
                        setCurrentStep(0);
                        setSteps?.(steps2);
                    } else {
                        setIsOpen(false);
                        setCurrentStep(0);
                        setSteps?.([]);
                        props?.di.globalState.removeLocalStorage('start_tour');
                    }
                }
            }
        })
    }

    const steps: StepType[] = [
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Horizontal Navigation Bar")}</Text>
                        <Text as="p">
                            {t("Switch between different sections of Settings from the navigation bar")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.bulktour_tab1',
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>Back</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Templates")}</Text>
                        <Text as="p">
                            {t("Click on ‘Templates’ to switch to the templates section (or Grid). Click on")} <Text as='strong'>{t("next")}</Text> {t("to proceed.")}
                            {/* From the horizontal tabs select <Text as='strong'>Templates</Text> tab.
                            Click on next to proceed. */}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.bulktour_tab1 #templateSettings',
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => {
                                    props?.handleTabChange(props.templateSettingsIndex)
                                    p?.nextClick()
                                }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("New Template")}</Text>
                        <Text as="p">
                            {t("Click on")} <Text as='strong'>{t("Add New Template")}</Text> {t("button to begin creating a new template.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '#bulktour_add_new_template_button',
            stepInteraction: true,
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{("Back")}</Button>
                                <Button size='slim' variant='primary' disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        }
    ]

    const steps2: StepType[] = [
        {
            selector: '.bulk_tour--template-grid',
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Template Grid")}</Text>
                        <Text as="p">
                            {t("Please wait while your products are being assigned to the template. Meanwhile, you can access all your templates here, with your most recent template appearing at the top. Click on “next” to proceed.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>Back</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            selector: '',
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("New template has been created")}</Text>
                        <Text as="p">
                            {t("You have successfully created a new template. Now you can proceed with STEP 2, which is to upload your products on Amazon.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>Back</Button> */}
                                <Button size='slim' variant='primary' onClick={() => {
                                    props?.di.POST('connector/config/saveConfig', {
                                        data: [
                                            {
                                                data: JSON.parse(
                                                    JSON.stringify(
                                                        {
                                                            bulk_upload_tour: {
                                                                parts_visited: 4,
                                                            },
                                                        }
                                                    )
                                                ),
                                                group_code: 'tour',
                                            },
                                        ],
                                    }).then((response: any) => {
                                        setIsOpen(false)
                                        setSteps?.([])
                                        setCurrentStep(0);
                                        if (response.success) {
                                            props.di.globalState.set('start_tour', 'bulk_upload_2');
                                            props.di.globalState.removeLocalStorage(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`);
                                            appBridgeRouting("product", props)
                                        }
                                        else props.error("Something went wrong")
                                    })
                                }} tone='success'>{t("Move to Step 2")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },

    ]

    useEffect(() => {
        if (props?.di.globalState.get('start_tour') === 'bulk_upload_1') {
            getTourData();
        } else {
            setIsOpen(false);
            setCurrentStep(0);
            setSteps?.([])
        }
    }, [])

    return null;
}

export default DI(ConfigTour)